<template>
  <div class="min-h-screen bg-[#FAF8F8] px-4 sm:px-6 py-12">
    <div class="max-w-4xl mx-auto bg-white rounded-2xl shadow-xs p-8 sm:p-10 border border-gray-100 space-y-8">
      <!-- En-tête -->
      <div class="border-b border-gray-100 pb-6">
        <div
          class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-50 border border-purple-200/60 text-xs font-semibold text-brand-purple mb-3">
          <span>⚖️</span> Informations Légales & Réglementaires
        </div>
        <h1 class="text-3xl font-extrabold text-[#0B2447] tracking-tight">
          Mentions Légales
        </h1>
        <p class="text-gray-500 text-xs mt-1">
          Dernière mise à jour : Février 2026
        </p>
      </div>

      <!-- 1. Éditeur de la Plateforme -->
      <section class="space-y-3">
        <h2 class="text-lg font-bold text-brand-purple flex items-center gap-2">
          <span>1.</span> Éditeur de la Plateforme
        </h2>
        <div class="text-gray-600 text-sm leading-relaxed space-y-1.5">
          <p>
            L'application SaaS et le service <strong>GiraafWorkflow</strong> sont édités et exploités par l'entreprise :
          </p>
          <div class="p-4 bg-gray-50 rounded-xl border border-gray-100 space-y-1 my-2">
            <p><strong>Dénomination sociale :</strong> GIRAAF PARK (جيراف بارك)</p>
            <p><strong>Forme juridique :</strong> Société Unipersonnelle à Responsabilité Limitée (SUARL)</p>
            <p><strong>Identifiant Unique (RNE) :</strong> <span
                class="font-mono font-bold text-[#0B2447]">1818868Y</span></p>
            <p><strong>N° de Registre :</strong> C01457402023</p>
            <p><strong>Activité principale :</strong> Activités informatiques (Code 72)</p>
            <p><strong>Direction & Gérance :</strong> Mme Afef Mosbeh</p>
            <p><strong>Siège social :</strong> Immeuble Montplaisir, 2ème étage, 25B Rue Omar Kaddah, Av. Kheireddine
              Pacha, Montplaisir, 1073 Bab Bhar, Tunis, Tunisie.</p>
          </div>
          <p>
            <strong>E-mail direct :</strong>
            <a href="mailto:contact@giraafpark.com"
              class="text-brand-purple font-semibold hover:text-brand-magenta hover:underline transition">
              contact@giraafpark.com
            </a>
            /
            <a href="mailto:growth@giraafpark.com"
              class="text-brand-purple font-semibold hover:text-brand-magenta hover:underline transition">
              growth@giraafpark.com
            </a>
            <br />
            <strong>Support client :</strong>
            <a href="tel:+21625030813" class="text-gray-700 font-medium hover:text-brand-purple transition">
              +216 25 030 813
            </a>
          </p>
        </div>
      </section>

      <!-- 2. Hébergement & Infrastructures Souveraines -->
      <section class="space-y-3">
        <h2 class="text-lg font-bold text-brand-purple flex items-center gap-2">
          <span>2.</span> Hébergement & Infrastructures Souveraines
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          L'hébergement principal de la plateforme, des bases de données et des sauvegardes est assuré par :<br />
          <strong>OVH SAS (OVHcloud)</strong><br />
          <strong>Siège social :</strong> 2 rue Kellermann - 59100 Roubaix - France<br />
          <strong>Datacentre :</strong> Gravelines (GRA), France / Europe<br />
          <strong>Site web officiel :</strong>
          <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer"
            class="text-brand-purple font-semibold hover:underline">
            www.ovhcloud.com
          </a>
        </p>
      </section>

      <!-- 3. Propriété Intellectuelle -->
      <section class="space-y-3">
        <h2 class="text-lg font-bold text-brand-purple flex items-center gap-2">
          <span>3.</span> Propriété Intellectuelle
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          L'intégralité du contenu de la solution logicielle <strong>GiraafWorkflow</strong> (marques déposées, logos,
          codes sources, interfaces utilisateurs, algorithmes et documentations) est la propriété exclusive de
          <strong>GIRAAF PARK</strong>.<br />
          Toute reproduction, distribution ou ingénierie inverse sans autorisation écrite expresse est strictement
          interdite.
        </p>
      </section>

      <!-- 4. Protection des Données Personnelles & Confidentialité -->
      <section class="space-y-3">
        <h2 class="text-lg font-bold text-brand-purple flex items-center gap-2">
          <span>4.</span> Protection des Données Personnelles
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          Conformément aux réglementations sur la protection des données personnelles (loi organique tunisienne n°
          2004-63 et standards RGPD), vous disposez d'un droit permanent d'accès, de rectification, de portabilité et de
          suppression de vos données en adressant une demande écrite à <a href="mailto:contact@giraafpark.com"
            class="text-brand-purple hover:underline">contact@giraafpark.com</a>.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MentionsLegalesView'
}
</script>
